module.exports = __webpack_public_path__ + "img/device.b06838b7.png";